@if (sterilisationPacks$ | async; as packs) {
  @if (!packs.length) {
    <pr-empty-state image="list" title="packs configured" />
  } @else {
    <mat-list>
      @for (pack of packs; track pack.ref.path) {
        <div class="flex w-full items-center justify-between gap-4">
          <div class="h-full flex-1">
            <h3 class="!m-0">
              {{ pack.name }}
            </h3>
            <span class="mat-caption">
              {{ pack.description }}
            </span>
          </div>

          <div class="flex items-center justify-end gap-4">
            <div>
              <button mat-icon-button (click)="edit.emit(pack)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="delete.emit(pack)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }
    </mat-list>
  }
}
